module.exports = __webpack_public_path__ + "static/img/200128.070b320a.png";